import { API, graphqlOperation } from "aws-amplify";

import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import RuleForm from "components/rules/RuleForm";
import {
  createRuleDevice,
  deleteRuleDevice,
  updateRule,
} from "graphql/mutations";
import { customGetRule } from "graphql/custom-queries";
import { Loader } from "@aws-amplify/ui-react";
import { listRuleDevices } from "graphql/queries";

const RuleUpdateForm = ({ ruleId, onSuccess }) => {
  const navigate = useNavigate();
  const [rule, setRule] = useState();

  async function onSubmit(values) {
    try {
      const {
        name,
        description,
        action,
        actionValue,
        devices,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = values;
      const promises = [];

      const devicesToUnLink = rule.devices
        ?.filter(
          (ruleUs) => !devices?.some((device) => device.id === ruleUs.id)
        )
        ?.map((device) => device.id);
      devicesToUnLink?.forEach(async (deviceId) => {
        const ruleDeviceRecords = (
          await API.graphql({
            query: listRuleDevices.replaceAll("__typename", ""),
            variables: {
              filter: {
                and: [
                  { deviceId: { eq: deviceId } },
                  { ruleId: { eq: ruleId } },
                ],
              },
            },
          })
        )?.data?.listRuleDevices?.items;
        promises.push(
          API.graphql({
            query: deleteRuleDevice.replaceAll("__typename", ""),
            variables: {
              input: {
                id: ruleDeviceRecords[0].id,
              },
            },
          })
        );
      });
      const devicesToLink = devices
        ?.filter(
          (device) =>
            !rule.devices?.some((ruleDevice) => ruleDevice.id === device.id)
        )
        ?.map((device) => device.id);
      devicesToLink?.forEach((deviceId) => {
        promises.push(
          API.graphql({
            query: createRuleDevice.replaceAll("__typename", ""),
            variables: {
              input: {
                ruleId,
                deviceId,
              },
            },
          })
        );
      });

      promises.push(
        API.graphql({
          query: updateRule.replaceAll("__typename", ""),
          variables: {
            input: {
              id: ruleId,
              name,
              description,
              action,
              actionValue,
              smsNotifications,
              wspNotifications,
              emailNotifications,
              conditions: JSON.stringify(conditions),
              companyID,
              startSchedule,
              endSchedule,
              days,
              execInterval,
              execTime,
              hourInterval,
              executeOnHolidays,
            },
          },
        })
      );
      await Promise.all(promises);
      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/rules");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchRule(id) {
    try {
      const ruleData = await API.graphql(
        graphqlOperation(customGetRule, { id })
      );
      const ruleItem = ruleData.data.getRule;
      if (!ruleItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/rules");
        return;
      }
      const {
        name,
        description,
        devices,
        action,
        actionValue,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = ruleItem;
      setRule({
        name,
        description,
        devices: devices.items?.map((ruleDev) => ({
          id: ruleDev.device.id,
          name: ruleDev.device.name,
        })),
        action,
        actionValue,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions: JSON.parse(conditions ?? "[]"),
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchRule(ruleId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ruleId]);

  if (!rule) return <Loader />;

  return (
    <div>
      <RuleForm onSubmit={onSubmit} type="update" initialValues={rule} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Regla",
    successUpdated: "Regla actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la regla",
    },
  },
});

export default RuleUpdateForm;
